/**************************************************
 * Nombre:       Tarjeta_Caracteristicas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../Constantes";

const Tarjeta_Caracteristicas = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{color: '#fff'}}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <img src={item.img} width={80} height={'auto'}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Typography sx={{
                    fontFamily: NEGRITA,
                    fontSize: 32,
                    fontWeight: 600,
                    textAlign: 'center'
                }}>{item.nombre}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Typography sx={{fontSize: 16, fontWeight: 400, textAlign: 'center'}}>{item.descripcion}</Typography>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Caracteristicas